export async function createNewOrgMember({ firebase }, payload) {
  const createUserCall = firebase.functions().httpsCallable("createOrgMember");
  return await createUserCall(payload);
}
